export const credentialsSchema = {
    type: 'object',
    properties: {
        spreedly: {
            type: 'object',
            properties: {
                gateway: { type: 'string' },
            },
        },
    },
};
